export default "__VITE_ASSET__2739ca86__"